import { getAll, getByTag } from "../utilities/querySelector";

for ( const image of getByTag( 'img' ) ) {

    const handler = e => {
        e.currentTarget.classList.remove( 'loading' );
        fadeIn( e.currentTarget );
    };
    image.addEventListener( 'load', handler, {
        once: true
    } );
    if ( !image.complete && image.tagName === "IMG" ) {
        image.classList.add( 'loading' );
    } else {
        image.classList.remove( 'loading' );
        image.removeEventListener( 'load', handler );
    }
};

function fadeIn(el) {
    el.animate( {
        opacity: [0, 1]
    }, 600 );
}

/*
CSS to combo
.loading {
  opacity: 0;
}
*/